import { Navigate, useParams } from "react-router-dom";

const ShareCartLanding = () => {
    const { cartId } = useParams();

    return <Navigate to={`/cart/${cartId}`} replace />;
};

export default ShareCartLanding;
